<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Why aren't any rental, ebooks, used etc. options showing?</h1>

			<p>
				The available options for any item are determined by two factors:
			</p>

			<ul>
				<li>If the only item available is a new item, it is likely your professor determined this item should only be available as a new item.</li>
				<li>If there are some options, but not the one you want, it is because no one is able to provide that option.</li>
			</ul>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "WhyOptionsArentShowing",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>